import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import ProblemSection from "./components/ProblemSection";
import SolutionSection from "./components/SolutionSection";
import StatsSection from "./components/StatsSection";
import BenefitsGrid from "./components/BenefitsGrid";
import ServicesOverviewSection from "./components/ServicesOverviewSection";
import IndustriesSection from "./components/IndustriesSection";
import ValueProposition from "./components/ValueProposition";
import ProcessSection from "./components/ProcessSection";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <div className="bg-[#050507] min-h-screen">
      <link
        href="https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700;800&family=Inter:wght@300;400;500;600&display=swap"
        rel="stylesheet"
      />
      <Navbar />
      <main>
        <HeroSection />
        <ProblemSection />
        <SolutionSection />
        <StatsSection />
        <BenefitsGrid />
        <ServicesOverviewSection />
        <IndustriesSection />
        <ValueProposition />
        <ProcessSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
